import Script from 'next/script';

export const GoogleEnhancedConversionTY = () => {
  //minified at https://www.toptal.com/developers/javascript-minifier
  const basecode = `
    window.dataLayer = window.dataLayer || [];
    var UIDLSTKAD = null;
    
    async function formSubmitted(message) {
      try {
        UIDLSTKAD = sessionStorage.getItem("uid-ls-tkad");
      } catch (e) {
      } finally {
       if(UIDLSTKAD != null) {
        dataLayer.push({
          'event':'ec_formsubmit',
          'user_data': {
            "email": UIDLSTKAD
            }
          });
        }
      }
    }

    formSubmitted();
`;
  return (
    <>
      <Script
        id="google-enhanced-conversion-scripts-ty"
        strategy="afterInteractive"
      >
        {`window.dataLayer=window.dataLayer||[];var UIDLSTKAD=null;async function formSubmitted(t){try{UIDLSTKAD=sessionStorage.getItem("uid-ls-tkad")}catch(a){}finally{dataLayer.push({event:"ec_formsubmit",user_data:{email:UIDLSTKAD}})}}formSubmitted();`}
      </Script>
    </>
  );
};
